module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/codesq.9fe49d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newhome/codesq.png
// module id = ry/1
// module chunks = 0